// extracted by mini-css-extract-plugin
export default {"container":"RegisterSuccess_container__gfJIJ","message":"RegisterSuccess_message__O1XjQ"};